import { apiDataService } from "@/services/apiDataService";
export default {
	namespaced: true,
	state: {
		users: [],
		error: null,
		loading: false,
	},
	mutations: {
		SET_USERS(state, users) {
			state.users = users;
		},
		SET_ERROR(state, error) {
			state.error = error;
		},
		SET_LOADING(state, loading) {
			state.loading = loading;
		},
	},
	actions: {
		async fetchUsers({ commit }) {
			commit("SET_LOADING", true);
			try {
				const response = await apiDataService.getUsers(3);
				commit("SET_USERS", response.data);
			} catch (error) {
				commit("SET_ERROR", error);
			} finally {
				commit("SET_LOADING", false);
			}
		},
	},
	getters: {
		allUsers(state) {
			return state.users;
		},
		userError(state) {
			return state.error;
		},
		isLoading(state) {
			return state.loading;
		},
	},
};
